import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    project,
    projectResource,
  }: Boundaries["removeResourceFromProject"]["request"],
): State {
  const index = state.findIndex(
    (res) =>
      res.projectResource.uuid === projectResource.uuid &&
      res.project.uuid === project.uuid,
  );

  return [
    ...state.slice(0, index),
    { project, projectResource, request: setRequestStateToPending() },
    ...state.slice(index + 1),
  ];
}

function handleSuccess(
  state: State,
  {
    project,
    projectResource,
  }: Boundaries["removeResourceFromProject"]["success"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid &&
    res.project.uuid === project.uuid
      ? { ...res, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  {
    project,
    projectResource,
  }: Boundaries["removeResourceFromProject"]["failure"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid &&
    res.project.uuid === project.uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeResourceFromProjectRequested]: handleRequest,
    [events.removeResourceFromProjectSucceeded]: handleSuccess,
    [events.removeResourceFromProjectFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
